import { Platform, StyleSheet } from 'react-native';

import { blackTransparent } from 'utils/colors';
import {
    heightPercentageToDP,
    isPhone,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

import { ImageSize } from 'components/NagraImage/types';

const styles = StyleSheet.create({
    container: {
        flexGrow: isTablet ? 0 : 1,
        marginTop: Platform.select({
            web: 56,
            default: heightPercentageToDP(40, 56),
        }),
        justifyContent: isPhone ? 'flex-start' : 'center',
    },
    profileItemContainer: {
        marginRight: isTabletOrWeb ? 56 : 0,
    },
    profileLogoContainer: {
        width: ImageSize.PROFILE_IMAGE.width,
        height: ImageSize.PROFILE_IMAGE.width,
        alignSelf: 'center',
        marginBottom: 4,
    },
    profileLogoOverlay: {
        ...StyleSheet.absoluteFillObject,
        borderRadius: ImageSize.PROFILE_IMAGE.width,
        backgroundColor: blackTransparent(0.5),
    },
    profileLogoIcon: {
        position: 'absolute',
        top: isTabletOrWeb ? 39 : widthPercentageToDP(25),
        left: isTabletOrWeb ? 39 : widthPercentageToDP(25),
        zIndex: 1,
    },
});

export default styles;
